import { createContext, useContext } from 'react';
import { IBookingV4ServiceItem } from './types';

// Orchestration handlers owned by BookingV4Context, consumed by nested rows.
export type BookingV4Actions = {
  addNewStaff: () => void;
  changeStaff: (blockId: string) => void;
  pickStaffTime: (blockId: string) => void;
  toggleRequest: (blockId: string) => void;
  removeStaff: (blockId: string) => void;
  addNewService: (blockId: string) => void;
  removeService: (blockId: string, serviceId: string) => void;
  editStartTime: (blockId: string, service: IBookingV4ServiceItem) => void;
};

const BookingV4ActionsContext = createContext<BookingV4Actions | null>(null);

export const BookingV4ActionsProvider = BookingV4ActionsContext.Provider;

export const useBookingV4Actions = (): BookingV4Actions => {
  const ctx = useContext(BookingV4ActionsContext);
  if (!ctx) throw new Error('useBookingV4Actions must be used within BookingV4ActionsProvider');
  return ctx;
};
